import type React from 'react';

import Typography from '@core/Typography2';

export type Props = {
  children: string;
} & React.ComponentPropsWithoutRef<'p'>;

const FormStatusText = (props: Props): React.ReactElement => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { children, color, ...restProps } = props;

  return (
    <Typography
      color="supportText"
      component="p"
      variant="bodySecondary"
      {...restProps}
    >
      {children}
    </Typography>
  );
};

export default FormStatusText;
